







import { Component, Vue } from 'vue-property-decorator'
import restaurants, { RestaurantPublic } from '@/services/Restaurants'

@Component
export default class Offline extends Vue {}
